<template>
  <div>
    <div class="banner">
      <img src="@/assets/2026/l1.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/l2.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/l3.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/l4.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/l5.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/2026/l6.png">
    </div>

  </div>
</template>
<script>
export default {
  name: 'LeftNews'
}
</script>
<style lang="scss" scoped>
.news {
  overflow: hidden;

  .iframe-1 {
    border: 0;
    height: 1830px;
    margin-top: -100px;
    pointer-events: none;
    overflow: hidden;
  }
}

@media screen and (max-width: 600px) {
  .news {
    margin-top: 15px;
    .iframe-1 {
      //margin-top: -380px;
      height: 1840px;
    }
  }
}
</style>
